import { Icon, Input, InputNumber, message, Radio, Spin, Tooltip } from 'antd';
import React, { Component } from 'react';
import { connect } from "react-redux";
import '../../../asset/style/workflow/slide.css';
import { updateCountSlotWise } from '../../../redux_actions/bloodConfig.action';
import { setDeviceIdle } from '../../../redux_actions/device_status.action';
import {
    changeSlideName, changeSpecimenType, receivedPreviewStatus,
    setDropDistancePointLength,
    setDropDistancePointOnly,
    setFocusPoints,
    setObjectiveType,
    setPreviewStatusToConfirmed,
    setScanSpeed,
    setSpecimenType, takePreview,
    updatePreviewStatus
} from '../../../redux_actions/preview_status.action';
import { RegionSelectionConstants } from "../../../redux_constants/region_selection.constant";
import { ScanApiConstant } from '../../../redux_constants/scan.constant';
import {
    antdSpinLoaderSmallIcon,
    objectiveType,
    scanSpeed,
    slideType,
    specimenType
} from '../../../utils/const';
import { getKeyByValue, getSupportedSpecimenType, isNull, isTrue, notNull } from '../../../utils/utils';
import { getBarcodeCrop, getDefaultOverlayedMaskForSpecimen, getOverlayedMaskForPath } from '../preview_utils';
import { getRadioButtons } from "./scan_workflow_utils";
import {LoadingOutlined} from "@ant-design/icons";

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BM': specimenType.BM,
    'BLOOD': specimenType.BLOOD,
}

let SCAN_SPEED = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW,
    'ZSTACK': scanSpeed.ZSTACK,
}

let SCAN_SPEED_NORMAL = {
    'Minor': scanSpeed.FAST,
    'Few': scanSpeed.MEDIUM,
    'Major': scanSpeed.SLOW
}

let OBJECTIVE = {
    '20x': objectiveType.TWENTY_X,
    '40x': objectiveType.FORTY_X,
    '100x': objectiveType.HUNDRED_X,
}

const initialState = {
    objective: null,
    takePreview: false,
    isFetching: false,
    barcodeAngle: -90,
    selected: false,
    slide_name: "",
    nameIsInvalid: false,
    firstLoad: true,
    WBCCount: 100,
    date: new Date(),
}

class SlideView extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount = () => {

        // regex_barcode

        // ^([R]{1,1})([0-9]{0,})-([0-9]{2,2})-([0-9]{2,2})-([0-9]{3,3})([A-Z]{1,1})$

        // verify_barcode true

        if ((this.props.preview || {}).slideName !== undefined) {
            this.setState({slide_name: (this.props.preview || {}).slideName})
        }
        
        let supportedSpecs = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes
        SPECIMEN = getSupportedSpecimenType(SPECIMEN, supportedSpecs, true);
       
        let slot_status = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus[this.props.slot_id]

        if (slot_status !== undefined) {
            if (slot_status?.previewStage === RegionSelectionConstants.CONFIRMED) {
                this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, (slot_status || {}).previewResponse, this.props.slot_id));
                this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
            } else {
                this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, (slot_status || {}).previewResponse, this.props.slot_id));
            }
        }

        if(slot_status && slot_status.previewResponse && slot_status.previewResponse.specimenType && this.props.preview.specimenType != slot_status.previewResponse.specimenType) {
            this.props.dispatch(setSpecimenType(this.props.slot_id, slot_status.previewResponse.specimenType))
        }

        this.setState({
            objective: getKeyByValue(OBJECTIVE, Object.keys(this.props.preview || {}).length === 0 ? this.props.defaultConfig.objectiveType : this.props.preview.objectiveType),
            slot_status: null,
        });

        if ((this.props.preview || {}).slideName !== undefined && (this.props.preview || {}).slideName.length > 0) {
            this.props.dispatch(changeSlideName(this.props.device_id, this.props.slot_id, (this.props.preview || {}).slideName));
        }

        let actualReg = ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id] || {}).regionSelected;
        let reg = {
            data: {index: 0}, height: 100, isChanging: false, new: false, width: 100, x: 0, y: 0,
        };
        if (notNull(actualReg) && actualReg.length !== 0) {
            this.props.dispatch(setPreviewStatusToConfirmed(this.props.slot_id, reg, actualReg))
        } else if (slot_status?.previewStage && slot_status.previewStage === RegionSelectionConstants.FETCHED_IMAGE) {
            this.createCanvas((this.props.preview || {}).specimenType, reg);
            this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
        }

        if (((this.props.bloodConfig || {}).countWBCSlotWise || {})[this.props.slot_id]) {
            this.setState({
                WBCCount: ((this.props.bloodConfig || {}).countWBCSlotWise || {})[this.props.slot_id]
            })
        }
    }

    sendbacktoparent = (val) => {
        this.props.onNameValid(val, this.props.slot_id)
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.preview || {}).slideName !== (this.props.preview || {}).slideName) {
            this.setState({
                slide_name: (this.props.preview || {}).slideName
            })
        }

        if ((this.props.preview || {}).slideName && (prevProps.preview || {}).slideName && this.state.firstLoad) {
            this.setState({nameIsInvalid: this.isValid((this.props.preview || {}).slideName)})
            this.setState({firstLoad: false})
        }

        if (prevProps.preview?.status !== RegionSelectionConstants.CONFIRMED && this.props.preview?.status === RegionSelectionConstants.CONFIRMED) {
            this.sendbacktoparent(this.isValid((this.props.preview || {}).slideName))
        }

        let prevPreviewStatus = (((prevProps.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;
        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;
        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (parseInt(key) === this.props.slot_id) {
                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.FETCHED_IMAGE) || (prevPreviewStatus[key] !== undefined && prevPreviewStatus[key].previewStage !== RegionSelectionConstants.FETCHED_IMAGE && value.previewStage === RegionSelectionConstants.FETCHED_IMAGE)) {
                    this.confirmPreviewStatus(value.previewResponse);
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, value.previewResponse, key));
                }

                if ((prevPreviewStatus[key] === undefined && value.previewStage === RegionSelectionConstants.CONFIRMED) || (prevPreviewStatus[key] !== undefined && ((prevPreviewStatus[key].previewStage !== RegionSelectionConstants.CONFIRMED && value.previewStage === RegionSelectionConstants.CONFIRMED) || (prevPreviewStatus[key].previewConfirmedCount !== value.previewConfirmedCount && value.previewStage === RegionSelectionConstants.CONFIRMED)))) {
                    this.confirmPreviewStatus(value.previewResponse);
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, value.previewResponse, key));
                    this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
                }
            }

        }

        if(isNull(currPreviewStatus) || Object.keys(currPreviewStatus).length === 0) {
            if(Object.keys(prevPreviewStatus).includes(this.props.slot_id)) {
                if((prevPreviewStatus[this.props.slot_id]['previewStage'] === RegionSelectionConstants.FETCHED_IMAGE || prevPreviewStatus[this.props.slot_id]['previewStage'] === RegionSelectionConstants.CONFIRMED)) {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.INIT_PREVIEW, prevPreviewStatus[this.props.slot_id].previewResponse, this.props.slot_id));
                }
            }
        }

        if ((prevProps.preview || {}).status === RegionSelectionConstants.GETTING_IMAGE && (this.props.preview || {}).status === RegionSelectionConstants.CONFIRMED) {
            let reg = {
                data: {index: 0}, height: 100, isChanging: false, new: false, width: 100, x: 0, y: 0,
            };
            this.createCanvas((this.props.preview || {}).specimenType, reg);
        }
    }

    componentWillUnmount = () => {
        this.setState({
            initialState,
        });
    }

    thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

    createCanvas = (specimenTypeVal, reg) => {
        const thresholdContext = this.thresholdCanvas.getContext('2d');
        const thresholdImage = new Image();
        let slot_status = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id]
        let defaultMaskLocation = ((slot_status || {}).previewResponse || {}).defaultMaskLocation + "?d=" + this.state.date.getTime();
        if (specimenTypeVal == specimenType.HNE_TISSUE) {
            defaultMaskLocation = ((slot_status || {}).previewResponse || {}).defaultHneMaskLocation + "?d=" + this.state.date.getTime();
        } else if (specimenTypeVal == specimenType.IHC) {
            defaultMaskLocation = ((slot_status || {}).previewResponse || {}).defaultIhcMaskLocation + "?d=" + this.state.date.getTime();
        } else if (specimenTypeVal == specimenType.PAP) {
            defaultMaskLocation = ((slot_status || {}).previewResponse || {}).defaultPapMaskLocation + "?d=" + this.state.date.getTime();
        } else if (specimenTypeVal == specimenType.BM) {
            defaultMaskLocation = ((slot_status || {}).previewResponse || {}).defaultBmMaskLocation + "?d=" + this.state.date.getTime();
        } else if (specimenTypeVal == specimenType.BLOOD) {
            defaultMaskLocation = ((slot_status || {}).previewResponse || {}).defaultBloodMaskLocation + "?d=" + this.state.date.getTime();
        }
        thresholdImage.src = "/dev-ssd/" + defaultMaskLocation;
        thresholdImage.onload = () => {
            thresholdContext.clearRect(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);
            thresholdContext.drawImage(thresholdImage, 0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);
            this.calculateThreshold(reg);
        }
    }

    calculateThreshold = (reg) => {
        let slot_status = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus[this.props.slot_id]
        let previewHeight = ((slot_status || {}).previewResponse || {}).previewHeight
        let previewWidth = ((slot_status || {}).previewResponse || {}).previewWidth
        let x1 = parseInt((reg.x * previewWidth) / 100.0);
        let x2 = parseInt(((reg.x + reg.width) * previewWidth) / 100.0);
        let y1 = parseInt((reg.y * previewHeight) / 100.0);
        let y2 = parseInt(((reg.y + reg.height) * previewHeight) / 100.0);
        let actualReg = [x1, y1, x2, y2];
        this.props.dispatch(setPreviewStatusToConfirmed(this.props.slot_id, reg, actualReg));
        this.props.dispatch(setDropDistancePointOnly(this.props.slot_id, slot_status.previewResponse.dropDistancePoint));
        this.props.dispatch(setFocusPoints(this.props.slot_id, slot_status.previewResponse.focusPoints));
        this.props.dispatch(setDeviceIdle(this.props.device_id));
    }

    confirmPreviewStatus = (response) => {
        if (response !== undefined) {
            let region = this.props.preview.region !== undefined ? this.props.preview.region : {};
            let actualRegion = this.props.preview.actualRegion !== undefined ? this.props.preview.actualRegion : [];
            this.props.dispatch(setPreviewStatusToConfirmed(this.props.slot_id, region, actualRegion));
            this.props.dispatch(setDropDistancePointOnly(this.props.slot_id, (response || {}).dropDistancePoint));
            this.props.dispatch(setDropDistancePointLength(this.props.slot_id, (response || {}).dropDistancePoint));
            this.props.dispatch(setFocusPoints(this.props.slot_id, response.focusPoints));
            this.props.dispatch(setDeviceIdle(this.props.device_id));
            // this.props.dispatch(updatePreviewStatus(this.props.slot_id, RegionSelectionConstants.CONFIRMED));
            this.setState({
                isFetching: false, date: new Date()
            });
        }

    }

    setTissueType = (value) => {

        let isFetchingAllPreviews = false;

        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;

        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                isFetchingAllPreviews = true;
                break;
            }
        }
        this.props.dispatch(changeSpecimenType(this.props.device_id, this.props.slot_id, value));

        if ((this.props.preview || {}).region !== undefined && !(isFetchingAllPreviews || !((this.props.preview || {}).status === RegionSelectionConstants.CONFIRMED && ((this.props.preview || {}).dropDistancePoint !== undefined && (this.props.preview || {}).dropDistancePoint.length > 0)))) {
            this.createCanvas(SPECIMEN[value], this.props.preview.region);
        }
    }

    setScanSpeed = (value) => {
        this.props.dispatch(setScanSpeed(this.props.slot_id, value));
    }

    setObjectiveType = (value) => {
        this.setState({
            objective: value
        });
        this.props.dispatch(setObjectiveType(this.props.slot_id, OBJECTIVE[value]));
    }

    takePreview = () => {
        if (!(this.props.deviceStatus[this.props.device_id] || {}).uiBusy) {
            this.setState({
                isFetching: true, date: new Date()
            });
            this.props.dispatch(takePreview(this.props.device_id, this.props.slot_id));
        }
    }

    expandEditor = () => {
        this.props.expandedSlideView(this.props.slot_id);
    }

    rotateBarcode = () => {
        this.setState({
            barcodeAngle: this.state.barcodeAngle + 90,
        })
    }

    isValid = (name_to_check) => {
        let regex = new RegExp('^$')
        regex = new RegExp(((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).regex_barcode)
        return !regex.test(name_to_check)
    }

    setSlideName = (e) => {
        this.props.dispatch(changeSlideName(this.props.device_id, this.props.slot_id, e.target.value));
        this.setState({nameIsInvalid: this.isValid(e.target.value)})
        this.sendbacktoparent(this.isValid(e.target.value))
        this.setState({slide_name: e.target.value})
    }

    toggleSelection = () => {
        this.setState({
            selected: !this.state.selected,
        })
    }

    setWBCCount = (count) => {
        this.setState({
            WBCCount: count,
        })
        this.props.dispatch(updateCountSlotWise([this.props.slot_id, count]));
    }

    render() {

        if (isNull(this.props.preview)) return;

        let deviceType = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {})['deviceType']
        let isHemoLens = deviceType && deviceType.includes("HEMOLENS");
        let runningAdvancedMode = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {})['runningAdvancedMode'];
        let isFetchingAllPreviews = false;

        let currPreviewStatus = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus;
        for (const [key, value] of Object.entries(currPreviewStatus)) {
            if (value.previewOngoing) {
                isFetchingAllPreviews = true;
                break;
            }
        }

        let showNameField = (this.props.preview && (this.props.preview.status === RegionSelectionConstants.CONFIRMED || this.props.preview.status === RegionSelectionConstants.FETCHED_IMAGE) && this.props.preview.status !== RegionSelectionConstants.ERRORED_OUT && this.props.preview.status !== RegionSelectionConstants.CANCELLED && this.props.preview.status !== RegionSelectionConstants.GETTING_IMAGE && ((this.props.preview || {})['response'] || {}).slideName !== undefined);


        let speedRadioButtons = (this.props.preview?.speed || "").toUpperCase() === scanSpeed.ZSTACK ?
            <Radio.Button checked={true} defaultChecked={true} value={scanSpeed.ZSTACK} style={{padding: '0px 4px'}}>
                {scanSpeed.ZSTACK}
            </Radio.Button> : getRadioButtons(SCAN_SPEED_NORMAL, this.props.preview?.speed, !showNameField);

        let objectiveTypeButtons = Object.keys(OBJECTIVE).map((objective) => {
            return <Radio.Button value={objective} style={{padding: '0px 4px'}}>
                {objective}
            </Radio.Button>
        });

        const specimenOptions = (<div style={{padding: '2px 0px', marginTop: 2}}>
            <Radio.Group size={'small'} className={'radio-group-button'}
                         value={this.props.preview?.specimenType}
                         onChange={(e) => {
                             e.stopPropagation();
                             this.setTissueType(e.target.value)
                         }}
                         disabled={false}
            >
                {getRadioButtons(SPECIMEN, this.props.preview?.specimenType, !showNameField)}
            </Radio.Group>
        </div>)

        const scanSpeedOptions = (<div style={{padding: '2px 0px'}}>

            <Radio.Group size={'small'} className={'radio-group-button'}
                         value={this.props.preview?.speed}
                         onChange={(e) => {
                             e.stopPropagation();
                             this.setScanSpeed(e.target.value)
                         }}
                         disabled={false}
            >
                {speedRadioButtons}
            </Radio.Group>
        </div>)

        let titleError = <span>Invalid <br/>Name</span>
        const nameField = (<div>
            {showNameField ? <React.Fragment>
                <Tooltip visible={this.state.nameIsInvalid && this.props.barcodeVerify} placement="left"
                         title={titleError} color="red">
                    <Input bordered="true" size="small" placeholder="Slide Name" spellCheck={false} autoComplete="off"
                           style={(this.state.nameIsInvalid && this.props.barcodeVerify) ? {
                               borderColor: "red", margin: '1px 0px'
                           } : {margin: '1px 0px'}}
                           onChange={this.setSlideName} value={this.state.slide_name}/>
                </Tooltip>
            </React.Fragment> : null}
        </div>)

        const objectiveTypeOptions = (<div style={{padding: '2px 0px'}}>
            <Radio.Group size={'small'} value={this.state.objective} className={'radio-group-button'}
                         onChange={(e) => {
                             e.stopPropagation();
                             this.setObjectiveType(e.target.value)
                         }}>
                {objectiveTypeButtons}
            </Radio.Group>
        </div>)

        const autoPreviewThreshold = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).autoPreviewThreshold;

        let quickSettings = null;
        this.props.preview?.specimenType === specimenType.BM ? quickSettings =
            <div className='quick-settings-button-group'>
                {specimenOptions}
                <div style={{padding: '2px 0px', marginTop: 2}}><b>{isHemoLens ? "# WBC:" : "# FLD:"}</b>
                    <InputNumber min={1} max={5000} value={this.state.WBCCount} onChange={this.setWBCCount}
                                 style={{height: '23px'}}/>
                </div>
                {nameField}
            </div> : quickSettings = <div className='quick-settings-button-group'>
            {autoPreviewThreshold !== true ? specimenOptions : null}
            {scanSpeedOptions}
            {nameField}
        </div>

        let slide = null;
        const enoughScanArea = ((((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus || {})[this.props.slot_id] || {}).previewResponse || {}).enoughScanArea;
        let previewOngoing = (((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).scanPreviewStatus || {})[this.props.slot_id] || {}).previewOngoing;

        if ((this.props.preview['status'] == RegionSelectionConstants.FETCHED_IMAGE || this.props.preview['status']== RegionSelectionConstants.CONFIRMED) &&
        (this.props.preview['response']!== undefined && this.props.preview['response']['uploadLocation'].length !== 0)) {
			let d = new Date();
			let srcImageUrl = getOverlayedMaskForPath(this.props.slot_id) + '?d=' + this.state.date.getTime();
			if (autoPreviewThreshold !== true && this.props.preview['status'] === RegionSelectionConstants.FETCHED_IMAGE) {
				srcImageUrl = getDefaultOverlayedMaskForSpecimen(this.props.preview.specimenType, this.props.slot_id)
			}
			slide = <div className={autoPreviewThreshold !== true ? (this.props.slideType === slideType.SLIDE_1_BY_3_INCH ? 'filled-preview-container' : 'filled-preview-container-2by3') : 'filled-container-auto-preview-threshold'}
						 style={(!isTrue(enoughScanArea)) ? {boxShadow: '0px 4px 8px 2px red'} : (this.props.preview.status === RegionSelectionConstants.CONFIRMED ? {boxShadow: '0px 4px 8px 2px green'} : {boxShadow: '0px 4px 8px 2px rgba(0,0,0,0.5)'})}>
				<Tooltip placement="rightTop"
						 title={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ?
							 (!isTrue(enoughScanArea) ? "No tissue selected" : "Click to modify scan settings") : ""}
                             visible={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) && !isTrue(enoughScanArea)}>
					<div onClick={this.expandEditor}
						 className={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ?
							 "filled-slide" : "filled-action-ongoing-slide"}>
						<p>Change Scan Region</p>
						<img className="slot-image" src={srcImageUrl}/>
                    </div>
                </Tooltip>
                <Tooltip placement="rightTop" title={"Rotate Barcode"}>

                    <div className="barcode-filled" onClick={this.rotateBarcode}>
                        <img key={Math.random()} className="barcode-image"
                             src={getBarcodeCrop(this.props.slot_id) + '?d=' + this.state.date.getTime()}
                             style={{transform: 'rotate(' + this.state.barcodeAngle + 'deg)'}}/>

                        <div className="rotate"><Icon type="reload"/></div>
                    </div>
                </Tooltip>
                <div style={{display: 'flex', align: 'bottom', borderTop: '2px solid black'}}>
                    {quickSettings}
                </div>
            </div>
        } else {
            slide = <div
                className={(this.props.preview || {}).status === RegionSelectionConstants.CONFIRMED ?
                    ( autoPreviewThreshold !== true ? (this.props.slideType === slideType.SLIDE_1_BY_3_INCH ? 'empty-confirmed-preview-container' : 'empty-confirmed-preview-container-2by3'): 'empty-confirmed-container-auto-preview-threshold')
                    : (autoPreviewThreshold !== true ? (this.props.slideType === slideType.SLIDE_1_BY_3_INCH ? 'empty-unconfirmed-preview-container' : 'empty-unconfirmed-preview-container-2by3') : 'empty-unconfirmed-container-auto-preview-threshold')}>
                <div
                    onClick={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) && !runningAdvancedMode ? this.takePreview : (e) => {
                        e.stopPropagation();
                        message.error("Scanner already in USE!", 2.5);
                    }} className="centered empty-slide"
                    style={!((this.props.deviceStatus[this.props.device_id] || {}).uiBusy || isFetchingAllPreviews) ? {cursor: 'pointer'} : null}>
                    {previewOngoing ? '' : <p>Click to see the Auto-Detected Region</p>}
                </div>
                <div className="barcode-empty"></div>
                <div style={{display: 'flex', align: 'bottom', borderTop: '2px solid black'}}></div>
                <div style={{display: 'flex', align: 'bottom', borderTop: '2px solid black'}}>
                    {quickSettings}
                </div>
            </div>

        }
        let isScanning = (this.props.deviceStatus[this.props.device_id] || {})?.scanner_health?.scanner_response?.scanning;

        let busyOrder = ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).busyOrder || [])
        let scannerBusy = busyOrder.length !== 0;
        let busyDict = ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).busyDict || {})
        let busyMessage = busyDict[busyOrder[0]]

        return (<Spin indicator={antdSpinLoaderSmallIcon} style={{color: '#000'}}
                      spinning={previewOngoing !== undefined && previewOngoing}
                      tip={isTrue(previewOngoing) && !isScanning ? 'Taking Preview' : ""}>
            <div className='slide-container'>
                {slide}
                <canvas ref={this.thresholdCanvasRef} className="region-selection-canvas-new"
                        style={{display: 'none'}}/>
            </div>
        </Spin>)
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        previews: state.previewStatusReducer,
        preview: state.previewStatusReducer[ownProps.slot_id],
        deviceStatus: state.deviceStatusReducer,
        slot_id: ownProps.slot_id,
        bloodConfig: state.bloodConfigReducer,
    };
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(SlideView);
